import React, { useState } from 'react';
import axios from '../../api/apiClient';
import loadingSpinner from '../../assets/loading.gif';
import { token, domain } from '../Security';

import CloseIcon from '@mui/icons-material/Close';

export const ChangePasswordForm = ({
  isOpen,
  onClose,
  username,
  oldPassword,
  setOldPassword,
  newPassword,
  setNewPassword,
  handleUpdate }) => {
  const [errorState, setErrorState] = useState(false);
  const [isPasswordNotMatch, setIsPasswordNotMatch] = useState(false);
  const [isOldPasswordNotMatch, setIsOldPasswordNotMatch] = useState(false);
  const [confirmPassword, setConfirmPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    if (!oldPassword
      || !newPassword
      || !confirmPassword
    ) {
      setErrorState(true);
      return;
    }

    const isNotMatch = await logInToGetPassword(e);

    if (isNotMatch) {
      setIsOldPasswordNotMatch(true);
      return;
    } else {
      setIsOldPasswordNotMatch(false);
    }

    if (newPassword !== confirmPassword) {
      setIsPasswordNotMatch(true);
      return;
    }

    handleUpdate(e);
    setErrorState(false);
    setIsPasswordNotMatch(false);
    setIsOldPasswordNotMatch(false)
  };

  const logInToGetPassword = async (event) => {
    event.preventDefault();

    const data = {
      userName: username,
      password: oldPassword
    };

    const apiUrlFetch = domain + "/api/Authentication/login";

    try {
      setLoading(true);
      await axios.post(apiUrlFetch, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });
      return false;
    } catch (error) {
      setLoading(false);
      return true;
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    onClose();
    setNewPassword("")
    setOldPassword("")
    setConfirmPassword("")
    setErrorState(false);
    setIsPasswordNotMatch(false);
    setIsOldPasswordNotMatch(false);
  };

  return (
    <>
      <div className={`modal-overlay ${isOpen ? 'open' : ''}`}>
        {isOpen && (
          <div className="modal">
            <div className="popUp-header row">
              <div className="popUp-title">
                <h3 style={{ color: "#668fca" }}>Change Password</h3>
              </div>
              <div className="popUp-close">
                <CloseIcon onClick={() => handleClose()} />
              </div>
            </div>
            <div className="popUp-body">
              <div className="popUp-item info-item column">
                <div className="info-item-label">Username</div>
                <div className="info-item-input">
                  <input
                    readOnly
                    placeholder="Password"
                    value={username}
                    style={{ cursor: "not-allowed" }}
                  />
                </div>
                <span style={{
                  visibility: "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    "Please fill up this field"
                  }
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Old Password</div>
                <div className="info-item-input">
                  <input
                    type='password'
                    placeholder="Password"
                    value={oldPassword}
                    onChange={(e) => setOldPassword(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!oldPassword && errorState) || (isOldPasswordNotMatch) ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isOldPasswordNotMatch) ? "Doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">New Password</div>
                <div className="info-item-input">
                  <input
                    type='password'
                    placeholder="Password"
                    value={newPassword}
                    onChange={(e) => setNewPassword(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!newPassword && errorState) || (isPasswordNotMatch) ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isPasswordNotMatch) ? "Doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
              <div className="popUp-item info-item column">
                <div className="info-item-label">Confirm Password</div>
                <div className="info-item-input">
                  <input
                    type='password'
                    placeholder="Confirm Password"
                    value={confirmPassword}
                    onChange={(e) => setConfirmPassword(e.target.value)}
                  />
                </div>
                <span style={{
                  visibility: (!confirmPassword && errorState) || (isPasswordNotMatch) ? "visible" : "hidden",
                  color: "#ff6565",
                  fontSize: "12px"
                }}>
                  {
                    (isPasswordNotMatch) ? "Doesn't match"
                      :
                      "Please fill up this field"
                  }
                </span>
              </div>
            </div>
            <div className="buttons row" style={{ justifyContent: "end", padding: "20px 40px" }}>
              <button id="add-family"
                className="save row"
                onClick={(e) => submit(e)}>
                CHANGE
              </button>
            </div>
          </div>
        )}
      </div>
      {loading ? (
        <div style={{ position: "fixed", top: "50%", left: "50%", transform: "translate(-50%, -50%)", zIndex: "3005" }}>
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )
      }
    </>
  );
}